import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
export const Navigation = _ref => {
  let {
    type,
    accountType,
    page,
    claim_group
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
    variant: "tabs"
  }, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'wages',
    to: "/".concat(accountType, "/companies/").concat(claim_group.company_id, "/").concat(claim_group.id, "/").concat(type, "/wages")
  }, t('wages'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'contractors',
    to: "/".concat(accountType, "/companies/").concat(claim_group.company_id, "/").concat(claim_group.id, "/").concat(type, "/contractors")
  }, t('contractors')))));
};